import { CloseIcon, TickIcon } from './icons.jsx';

// The password requirements, listed under a new password and ticked off as it
// meets them, as the app's Password does with `showRules`
// (app/src/components/common/Password.js). The list only guides: darwin_core's
// passwordValidator is what checks the password, and these rules restate it, so
// the three have to change together.
const SYMBOL = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]/;

const RULES = [
  [(p) => p.length > 7 && p.length <= 24, 'Between 8 and 24 characters'],
  [
    (p) => /[a-z]/.test(p) && /[A-Z]/.test(p),
    'Contains both upper and lower case',
  ],
  [(p) => /\d/.test(p), 'A number'],
  [(p) => SYMBOL.test(p), 'A special character: {}[]?-!@#$%^&*<>:;|'],
];

// The same rules for Safari's password generator (the passwordrules attribute),
// copied from what the app gives iOS. Its symbols are a subset of SYMBOL, so a
// password Safari suggests passes the validator. Chrome ignores the attribute,
// and its suggestion can lack a special character; this list is what then shows
// the user which rule it misses.
export const PASSWORD_RULES_ATTRIBUTE =
  'minlength: 8; maxlength: 24; required: lower; required: upper; required: digit; required: [!#$%&*:;<>?@[^{|}]];';

export default function PasswordRules({ password }) {
  return (
    // role="list" because Safari stops announcing a list once its bullets are
    // styled away (list-style: none in index.css).
    <ul
      className="password-rules"
      role="list"
      aria-label="Password requirements"
    >
      {RULES.map(([test, text]) => {
        const met = test(password);
        return (
          <li
            key={text}
            className={`password-rules__rule${met ? ' password-rules__rule--met' : ''}`}
          >
            <span className="password-rules__icon" aria-hidden="true">
              {met ? <TickIcon /> : <CloseIcon />}
            </span>
            <span className="visually-hidden">
              {met ? 'Met: ' : 'Not met: '}
            </span>
            {text}
          </li>
        );
      })}
    </ul>
  );
}
